import React, { useEffect, useState } from "react";
import "rc-slider/assets/index.css";
import "./MentorFeedbackStyle.css";
import Button from "../../../components/Button/Button";
import RangeSlider from "../../../components/RangeSlider/RangeSlider";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { clearState, mentorData, saveUserFeedbackAnswers } from "../../../reducer/mentorSlice";
import PageLoader from "../../../components/loaders/PageLoader/PageLoader";
import SuccessToast from "../../../components/Toast/SuccessToast";
import ErrorToast from "../../../components/Toast/ErrorToast";
import InputField from "../../../components/InputField/InputField";

const MentorFeedback = () => {

    const [feedback, setFeedback] = useState({
        answer1: 0,
        answer2: "",
        answer3: "",
        answer4: 0,
    });
    const [others, setOthers] = useState("");
    const [index, setIndex] = useState(1);

    //Toast states
  const [isShowSuccess, setIsShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isShowError, setIsShowError] = useState(false);
  const [errMessage, setErrMessage] = useState("");

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { feedbackId } = useParams();

    const { isFetching, isSuccess, isThemeFetched, isError, errorMessage } = useSelector(mentorData);
    
    const validation = () => {
        if(index === 2) {
            if(feedback["answer2"] === '') return true;
            if(feedback["answer2"] === "Others" && !others) return true;
        }
        if(index === 3 && feedback["answer3"] === '') return true;
        return false;
    }

    const handleIndexChange = (type) => {
        if(type === "next") {
            if(!validation()) { 
                if(index === 4) {
                    const obj = feedback;
                    if(feedback["answer2"] === "Others") obj["answer2"] = others;
                    dispatch(saveUserFeedbackAnswers({feedbackId, obj}));
                    return;
                }
                setIndex(prev => prev + 1);
            }
            else {
                setIsShowError(true);
                setErrMessage("Feedback is mandatory!");
            }
        }
        else {
            if(index === 1) return;
            setIndex(prev => prev - 1);
            
        }
    };

    const handleSliderChange = (value,index) => {
        setFeedback(prev => ({
            ...prev,
            [`answer${index}`]: value
        }));
    };
    
    const handleRadioChange = (e, index) => {
        const { value } = e.target;
        setFeedback(prev => ({
            ...prev,
            [`answer${index}`]: value
        }));
    };

    useEffect(() => {
        if(isSuccess) {
            setIsShowSuccess(true);
            setSuccessMessage("Success");
            setTimeout(() => {
                navigate("/mentor/call-records")
            }, 1000)
            dispatch(clearState());
        }
    },[isSuccess]);

    useEffect(() => {
        if(isError) {
            setIsShowError(true);
            setErrMessage(errorMessage)
            dispatch(clearState());
        }
    },[isError])

    return (
        <>
        {isFetching && <PageLoader />}
        <ErrorToast
        show={isShowError}
        setShow={() => setIsShowError(false)}
        message={errMessage}
      />
        <SuccessToast
        show={isShowSuccess}
        setShow={() => setIsShowSuccess(false)}
        message={successMessage}
      />
    <div className="MentorsFbackWrapper">

    <div className="logogetpreepedimg">
            <img src="/assets/svg/getPreppedLogo.svg" alt="" onClick={() => navigate('/mentee')}/>
        </div>

      <div className="MnFeedBackwrapper">
            {/* first */}
            <div className={`bodyDataForallUserdata Fbackformtabwrappermain ${index === 1 && 'active'}`}>
            <div className="MnfBackArea">
                <h3 className="Mnque-1">
                How was your <span>experience</span> with the <span>Mentee</span>{" "}
                ?
                </h3>
                <div className="RangeSliderWrapper">
                <RangeSlider onChange={(e) => handleSliderChange(e,1)} />
                </div>
            </div>
            </div>

            {/* second */}
            <div className={`bodyDataForallUserdata Fbackformtabwrappermain ${index === 2 && 'active'}`}>
            <div className="MnfBackArea">
                <h3 className="Mnque-1">
                What was the Mentee’s <span>problem</span> about ?
                </h3>
            </div>
            <div className="contentDatafback">

                    <label htmlFor="que1" className="quesFback"> 
                        <input type="radio" name="secondQuestion" value={"Looking for a new job/career switch"} id="que1" checked={feedback["answer2"] === "Looking for a new job/career switch"}  onChange={(e) => handleRadioChange(e,2)}/>
                        <span>Looking for a new job/career switch</span>
                    </label>
                    <label htmlFor="que2" className="quesFback"> 
                        <input type="radio" name="secondQuestion" value={"Feel stagnated in their current position"} id="que2" checked={feedback["answer2"] === "Feel stagnated in their current position"} onChange={(e) => handleRadioChange(e,2)} />
                        <span>Feel stagnated in their current position</span>
                    </label>
                    <label htmlFor="que3" className="quesFback"> 
                        <input type="radio" name="secondQuestion" value={"Unsure about what to do after graduation"} id="que3" checked={feedback["answer2"] === "Unsure about what to do after graduation"} onChange={(e) => handleRadioChange(e,2)} />
                        <span>Unsure about what to do after graduation</span>
                    </label>
                    <div className="quesinputarea flex">
                    <label htmlFor="que4" className="quesFback"> 
                        <input type="radio" name="secondQuestion" value={"Others"} id="que4" checked={feedback["answer2"] === "Others"} onChange={(e) => handleRadioChange(e,2)} />
                        <span>Others</span>
                    </label>
                    {feedback["answer2"] === "Others" && <input
                        type="text"
                        placeholder="Please Specify"
                        className="plsspecify w-100"
                        value={others}
                        onChange={e => setOthers(e.target.value)}
                    />}
                </div>
            </div>
            </div>

        {/* Third */}
            <div className={`bodyDataForallUserdata Fbackformtabwrappermain ${index === 3 && 'active'}`}>
            <div className="MnfBackArea">
                <h3 className="Mnque-1">
                {" "}
                Were you able to <span> come up </span> with an{" "}
                <span>action plan</span> for the Mentee?
                </h3>
            </div>
            <div className="flex RadioFbackform">
                <InputField type={"radio"} labelName={"Yes"} value={"yes"} id={"yes"} checked={feedback["answer3"] === "yes"} onChange={(e) => handleRadioChange(e,3)} />
                <InputField type={"radio"} labelName={"No"} value={"no"} id={"no"} checked={feedback["answer3"] === "no"} onChange={(e) => handleRadioChange(e,3)} />
                <InputField type={"radio"} labelName={"Maybe"} value={"maybe"} id={"maybe"} checked={feedback["answer3"] === "maybe"} onChange={(e) => handleRadioChange(e,3)} />
            </div>
            </div>

        {/* Four */}
            <div className={`bodyDataForallUserdata Fbackformtabwrappermain ${index === 4 && 'active'}`}>
            <div className="MnfBackArea">
                <h3 className="Mnque-1">
                {" "}
                How would you <span>rate</span> the Mentee’s{" "}
                <span>employability</span>, if you were <span>to hire</span> them
                for your own team?
                </h3>

                <div className="RangeSliderWrapper">
                <RangeSlider onChange={(e) => handleSliderChange(e,4)} />
                </div>
            </div>
            </div>

            <div className="border-btm w-100"></div>
            <div className="Headingforallheader">
                <div className="pagesdotesWrappper">
                    <span className={`pagesdotescircle ${index === 1 && 'active'}`}></span>
                    <span className={`pagesdotescircle ${index === 2 && 'active'}`}></span>
                    <span className={`pagesdotescircle ${index === 3 && 'active'}`}></span>
                    <span className={`pagesdotescircle ${index === 4 && 'active'}`}></span>
                </div>

                <div className="buttonfbackfrom flex-between"> 
                {index === 1 ? <div></div> : <Button name={'Back'} className={'flex gap-5'} src={'/assets/img/arrow-circle-right.png'} onClick={() => handleIndexChange("back")}  /> }
                {<Button name={index === 4 ? 'Submit' : 'Next'} className={'BlackFillButton'} onClick={() => handleIndexChange("next")} />}
                </div>
            </div>
        </div>
      </div>
    </>
  );
};

export default MentorFeedback;
